import { render, staticRenderFns } from "./DeviceStatusView.vue?vue&type=template&id=36c3ee88&scoped=true"
import script from "./DeviceStatusView.ts?vue&type=script&lang=ts&external"
export * from "./DeviceStatusView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c3ee88",
  null
  
)

export default component.exports